import { axios } from '../../services/axios';

export default async function getCompany(companyId) {
    return axios
        .get(`/company/${companyId}`, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            },
        })
        .then((res) => res)
        .catch((e) => e);
}
